export const pagePaths = {
    login: '/',
    dckHome: '/counseling/home',
    signUp: '/sign-up',
    addDiagnosis: '/counseling/add-diagnosis',
    diagnosisList: '/counseling/diagnosis-list',
    viewDetaildiagnosis: '/counseling/detail-diagnosis',
    todayDiagnosis: '/counseling/today-diagnosis',
    managingPatients: '/counseling/managing-patients',
    viewDetailPatient: '/counseling/detail-patient',
    accountSetting: '/counseling/account-info',
    hospitalSetting: '/counseling/hospital-setting',
    adminDiagnosisList: '/admin/diagnosis-list',
    calculate: '/admin/calculate',
    assessmentPayment: '/admin/assessment-payment',
    adminManageUserJoin: '/admin/manage-user-join',
    adminManageHospital: '/admin/manage-hospital',
    mindUpAdminDiagnosisList: '/admin/mindup/consultation-list',
    mindUpAdminAllReservationConsultation: '/admin/mindup/all-reservation',
    mindUpAdminUserReservationConsultation: '/admin/mindup/user-reservation',
    mindUpAdminTodayDiagnosis: '/admin/mindup/today-diagnosis',
    adminVoucherList: '/admin/voucher-list',
    adminCounselerList: '/admin/counseler-list',
    adminViewDetaildiagnosis: '/admin/detail-diagnosis',
    CLAdminManagePatient: '/admin/cl/managing-patients',
    CLAdminPatientInfo: '/admin/cl/patient-info/:userId',
    CLAdminPatientInfoBase: '/admin/cl/patient-info',
    CLAdminUserLookup: '/admin/cl/users',
    CLAdminUserDetail: '/admin/cl/users/:userId',
    CLAdminUserDetailBase: '/admin/cl/users',
    SettingsAdminUserRole: '/admin/settings/admin-users',
};

export const tabletPaths = {
    managerLogin: '/tablet/manager-login',
    login: '/tablet/login',
    information: '/tablet/information',
    startExamination: '/tablet/start-examination',
    userSurvey: '/tablet/userSurvey',
};

export const governmentPaths = {
    agree: '/government/agree',
    ready: '/government/ready',
    codeConfirm: '/government/code-confirm',
    selectAssessment: '/government/select-assessment/',
    inspectionGuide: '/government/inspection-guide',
    userInspection: '/government/user-inspection',
    complete: '/government/complete',
};

export const preciousChildPaths = {
    enterance: '/mindup/enterance',
    agreement: '/mindup/agreement',
    detailLegal: '/mindup/detailLegal',
    codeVerification: '/mindup/:purchaseCode',
    childInfo: '/mindup/child-info',
    parentInfo: '/mindup/parent-info',
    counselReason: '/mindup/counsel-reason',
    userInspection: '/mindup/user-inspection',
    inspectionGuide: '/mindup/inspections_guide',
    introduce: '/mindup/introduce',
    assessmentScript: '/mindup/assessment_script',
    counselReservation: '/mindup/reservation',
    complete: '/mindup/complete',
    result: '/mindup/result',
    aiAnalyze: '/mindup/ai-analyze',
    testHistoryList: '/mindup/test-history',
    sungnamAskToAi: '/mindup/ask-to-ai',
};

export const connectMindPaths = {
    detailLegal: '/sungnam/detailLegal',
    childInfo: '/sungnam/child-info',
    parentInfo: '/sungnam/parent-info',
    userInspection: '/sungnam/user-inspection',
    inspectionGuide: '/sungnam/inspections_guide',
    introduce: '/sungnam/introduce',
    assessmentScript: '/sungnam/assessment_script',
    complete: '/sungnam/complete',
    result: '/sungnam/result',
    aiAnalyze: '/sungnam/ai-analyze',
    testHistoryList: '/sungnam/test-history',
    sungnamAskToAi: '/sungnam/ask-to-ai',
    sungnamEnterance: '/sungnam/enterance/:codeKey',
    sungnamAgreement: '/sungnam/agreement',
    sungnamDetailLegal: '/sungnam/detailLegal',
    sungnamPurchaseCounselService: '/sungnam/purchase-consel-service',
    sungnamDiagnosisHistoryList: '/sungnam/diagnosis-history-list',
    counselReservation: '/sungnam/reservation',
    sungnamComplete: '/sungnam/complete',
    sungnamError: '/sungnam/error',
};

export const mindupAdminMobilePaths = {
    login: '/m.admin/mindup/login',
    mindUpAdminMobileUserReservationConsultation: '/m.admin/mindup/user-reservation',
    mindUpAdminMobileDetailDiagnosis: '/m.admin/mindup/detail-diagnosis',
    mindUpAdminMobileAllReservationConsultation: '/m.admin/mindup/all-reservation',
    MindUpAdminMobileCompletedUserCounsel: '/m.admin/mindup/completed-user-counsel',
    MindUpAdminMobileAccountSetting: '/m.admin/mindup/account-setting',
};

export const apiPaths = {
    login: `${process.env.REACT_APP_API_NODE}/auth/signin`,
    signUp: `${process.env.REACT_APP_API_NODE}/auth/oauth`,
    updateFcmToken: `${process.env.REACT_APP_API_NODE}/auth/updateFcmToken`,
    resetPasswordLink: `${process.env.REACT_APP_API_NODE}/user/sendPasswordResetLink/`,
    existUser: `${process.env.REACT_APP_API_NODE}/user/existUser/`,
    updateUserInfo: `${process.env.REACT_APP_API_NODE}/user/update`,
    GetReadByHospitalId: `${process.env.REACT_APP_API_NODE}/user/readByHospitalId/`,
    deleteUser: `${process.env.REACT_APP_API_NODE}/user/deleteUser/`,
    changeUserLevel: `${process.env.REACT_APP_API_NODE}/user/changeLevel`,
    sendPushNotification: `${process.env.REACT_APP_API_NODE}/diagnosis/sendPushNotification`,
    addDiagnosis: `${process.env.REACT_APP_API_NODE}/diagnosis/create`,
    getDiagnosisList: `${process.env.REACT_APP_API_NODE}/diagnosis/getList/`,
    getListByStatus: `${process.env.REACT_APP_API_NODE}/diagnosis/getListByStatus`,
    findByHospitalId: `${process.env.REACT_APP_API_NODE}/diagnosis/findByHospitalId/`,
    getPatientDiagnosisList: `${process.env.REACT_APP_API_NODE}/diagnosis/getListByPatientId/`,
    assignAssessment: `${process.env.REACT_APP_API_NODE}/diagnosis/assignAssessment`,
    changeDiagnosisStatus: `${process.env.REACT_APP_API_NODE}/diagnosis/changeStatus`,
    updateDiagnosisInfo: `${process.env.REACT_APP_API_NODE}/diagnosis/update`,
    getDiagnosis: `${process.env.REACT_APP_API_NODE}/diagnosis/findById/`,
    updateCounselDateTime: `${process.env.REACT_APP_API_NODE}/diagnosis/setCounselDateTime/`,
    updateAssignCounselor: `${process.env.REACT_APP_API_NODE}/diagnosis/assignCounselor/`,
    updateNoShowInfo: `${process.env.REACT_APP_API_NODE}/diagnosis/updateNoShowInfo/`,
    updateAssessmentAiResult: `${process.env.REACT_APP_API_NODE}/diagnosis/updateAssessmentAiResult/`,
    updateAiChatMessage: `${process.env.REACT_APP_API_NODE}/diagnosis/updateAiChatMessage/`,
    getListByDeviceKey: `${process.env.REACT_APP_API_NODE}/diagnosis/getListByDeviceKey/`,
    getDeviceKeyCount: `${process.env.REACT_APP_API_NODE}/diagnosis/getDeviceKeyCount`,
    compactList: `${process.env.REACT_APP_API_NODE}/hospital/getCompactList`,
    addDoctor: `${process.env.REACT_APP_API_NODE}/hospital/addDoctor`,
    removeDoctor: `${process.env.REACT_APP_API_NODE}/hospital/removeDoctor`,
    hospitalFindById: `${process.env.REACT_APP_API_NODE}/hospital/findById/`,
    getPatientInfo: `${process.env.REACT_APP_API_NODE}/patient/findById/`,
    updatePatient: `${process.env.REACT_APP_API_NODE}/patient/update`,
    getPatientList: `${process.env.REACT_APP_API_NODE}/patient/getList/`,
    patientChangeStatus: `${process.env.REACT_APP_API_NODE}/patient/changeStatus`,
    deletePatient: `${process.env.REACT_APP_API_NODE}/patient/deletePatient/`,
    clearDiagnosis: `${process.env.REACT_APP_API_NODE}/diagnosis/clearDiagnosis/`,
    patientFind: `${process.env.REACT_APP_API_NODE}/patient/find`,
    getAssessmentList: `${process.env.REACT_APP_API_NODE}/assessment/getList/`,
    getResultDiagnosis: `${process.env.REACT_APP_API_NODE}/assessment/getResultByDiagnosisId/`,
    findByCode: `${process.env.REACT_APP_API_NODE}/assessment/findByCode/`,
    getDiagnosisByDeviceKey: `${process.env.REACT_APP_API_NODE}/diagnosis/getListByDeviceKey/`,

    // admin
    paymentList: `${process.env.REACT_APP_API_NODE}/payment/getPayment`,
    getQuarterPayment: `${process.env.REACT_APP_API_NODE}/payment/getQuarterlyPayment`,
    getMonthlyPayment: `${process.env.REACT_APP_API_NODE}/payment/getMonthlyPayment/`,
    getAssessmentPayment: `${process.env.REACT_APP_API_NODE}/payment/getList/`,
    updateAssessmentPayment: `${process.env.REACT_APP_API_NODE}/payment/update/`,
    getUserList: `${process.env.REACT_APP_API_NODE}/user/getUserList`,
    userChangeStatus: `${process.env.REACT_APP_API_NODE}/user/changeStatus`,
    getHospitalList: `${process.env.REACT_APP_API_NODE}/hospital/getHospitalList`,
    getVoucherList: `${process.env.REACT_APP_API_NODE}/auth/voucherList`,
    getCounselerSchedule: `${process.env.REACT_APP_API_NODE}/user/schedule`,
    updateCounselerSchedule: `${process.env.REACT_APP_API_NODE}/user/schedule`,

    //태블릿
    getDiagnosisListData: `${process.env.REACT_APP_API_NODE}/diagnosis/findByDate`,
    getAssessmentData: `${process.env.REACT_APP_API_NODE}/assessment/findById`,
    getInpsytResult: `${process.env.REACT_APP_API_NODE}/assessment/getInpsytResult`,
    changeAssessmentStatus: `${process.env.REACT_APP_API_NODE}/assessment/changeStatus`,
    postSendPushNotification: `${process.env.REACT_APP_API_NODE}/notification/sendPushNotification`,

    // 바우처 및 구매코드 (외부 채널 구매 진입)
    verifyVoucherCode: `${process.env.REACT_APP_API_NODE}/auth/verifyVoucherCode`,
    changeVoucherStatus: `${process.env.REACT_APP_API_NODE}/auth/changeVoucherStatus`,
    createVoucherCode: `${process.env.REACT_APP_API_NODE}/auth/createVoucherCode`,

    // MindUp OpenAi
    verifyAiAccess: `${process.env.REACT_APP_API_NODE}/misc/verifyAiAccess/`,

    // 금쪽이 상담 달력 공휴일
    getHolidays: `${process.env.REACT_APP_SMS_API_NODE}/misc/getRestDate`,

    // 마음이음 구매
    getInfo: `${process.env.REACT_APP_SMS_API_NODE}/payment/getInfo`,

    // [Mind:Up] SEND SMS
    sendSms: `${process.env.REACT_APP_DOCTORON_API_NODE}/popbill/sendSMS`,
    sendVoucherMessage: `${process.env.REACT_APP_API_NODE}/alimtalk/sendVoucherMessage`,
    updateHospital: `${process.env.REACT_APP_API_NODE}/hospital/update`,
    createHospital: `${process.env.REACT_APP_API_NODE}/hospital/create`,
    uploadHospitalImages: `${process.env.REACT_APP_API_NODE}/hospital/uploadImages`,
    deleteHospitalImage: `${process.env.REACT_APP_API_NODE}/hospital/deleteHospitalImage`,
    updateDoctor: `${process.env.REACT_APP_API_NODE}/hospital/updateDoctor`,
    deleteHospital: `${process.env.REACT_APP_API_NODE}/hospital/delete/`,

    // OpenAI
    // openAiVerifyToken: `${process.env.REACT_APP_API_NODE}/openai/verifyToken`,
    tempOpenAiResponse: `${process.env.REACT_APP_API_NODE}/openai/responseAiResult`,

    getProducts: `${process.env.REACT_APP_SMS_API_NODE}/products`,

    // CL Admin
    CLAdminGetUserList: `${process.env.REACT_APP_CB_API_NODE}/user/getUserList`,
    CLAdminGetAllUserList: `${process.env.REACT_APP_CB_API_NODE}/user/getUserList`,
    CLAdminGetUserDetail: `${process.env.REACT_APP_CB_API_NODE}/web/users/`,
    CLWebGetUserList: `${process.env.REACT_APP_CB_API_NODE}/web/admin/users`,
    CLWebGetUserDetail: `${process.env.REACT_APP_CB_API_NODE}/web/admin/users/`,
    CLWebGetHospitalList: `${process.env.REACT_APP_CB_API_NODE}/web/admin/hospitals`,
    CLAdminAccountList: `${process.env.REACT_APP_CB_API_NODE}/web/admin/accounts`,
    CLAdminAccountCreate: `${process.env.REACT_APP_CB_API_NODE}/web/admin/accounts`,
    CLAdminAccountDelete: `${process.env.REACT_APP_CB_API_NODE}/web/admin/accounts/`,
    CLGetStatisticsByDate: `${process.env.REACT_APP_CB_API_NODE}/statistics/getStatisticsByDate`,
    CLGetNotificationList: `${process.env.REACT_APP_CB_API_NODE}/notifications/getNotificationList`,
    CLSendNotification: `${process.env.REACT_APP_CB_API_NODE}/notifications/sendNotification`,
    CLGetLegacyAiChatHistory: `${process.env.REACT_APP_CB_API_NODE}/aiChat/getHistory/`,
    CLGetAiChatHistory: `${process.env.REACT_APP_CB_API_NODE}/aiChat/v2/getHistory/`,
    CLGetFavoriteUserList: `${process.env.REACT_APP_CB_API_NODE}/user/getFavoriteUserList`,
    CLUpdateFavoriteUser: `${process.env.REACT_APP_CB_API_NODE}/user/updateFavoriteUser`,
    CLGetHospitalList: `${process.env.REACT_APP_CB_API_NODE}/hospital/getList`,
};
